export default "__VITE_ASSET__sC7qSeEL__"